import React from "react";

type ProfileIconProps = React.SVGProps<SVGSVGElement>;

export const ProfileIcon = ({
  width = 20,
  height = 20,
  ...props
}: ProfileIconProps) => (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M8.64147 12.0003H5.97491C5.26769 12.0003 4.58944 12.2813 4.08937 12.7814C3.58929 13.2814 3.30835 13.9597 3.30835 14.6669V16.0002M11.5114 13.0203L12.1267 12.7656M12.1267 11.235L11.5114 10.9797M13.2093 10.1524L12.954 9.53711M13.2093 13.8483L12.954 14.4642M14.7399 10.1524L14.9952 9.53711M14.9945 14.4642L14.7399 13.8483M15.8225 11.235L16.4385 10.9797M15.8225 12.7656L16.4385 13.021" stroke="#79808A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.9745 13.9998C15.079 13.9998 15.9744 13.1044 15.9744 11.9999C15.9744 10.8954 15.079 10 13.9745 10C12.87 10 11.9746 10.8954 11.9746 11.9999C11.9746 13.1044 12.87 13.9998 13.9745 13.9998Z" stroke="#79808A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.97483 9.33312C9.44753 9.33312 10.6414 8.13926 10.6414 6.66656C10.6414 5.19386 9.44753 4 7.97483 4C6.50213 4 5.30827 5.19386 5.30827 6.66656C5.30827 8.13926 6.50213 9.33312 7.97483 9.33312Z" stroke="#79808A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

export default ProfileIcon;
